<template>
    <div class="ApplicationLoader" :aria-label="ariaLabel">
        <div class="app-loader">
            <div class="app-loader-content">
                <div class="app-loader-bars"></div>
            </div>
            <div v-if="!hideText" class="app-loader-footer">
                <slot>Loading All The Things</slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        hideText: { type: Boolean, default: false },
        ariaLabel: { type: String, default: 'GeneralLoadingAllTheThings' }
    },
};
</script>
